import FinanceAdapter from './base';

export default class Account extends FinanceAdapter {
  modelNamePlural = 'accounts';
}
